module.exports = __webpack_public_path__ + "img/badge-bibliotheque-02.9144a2df.png";